<template>
  <div>
    <list-jenjang ref="jenjang" @reset="onResetTahap" @kriteria="onKriteria" @detail="onDetail" @kuota="onKuota" />
    <base-modal-full
      generalError
      :autoClose="formulir.mode === 'detail'"
      ref="modal"
      :title="formulir.title"
      :mode="formulir.mode"
      @save="onSave"
      @close="onClose"
    >
      <component
        ref="component"
        :mode="formulir.mode"
        :is="formulir.form"
        :initValue="formulir.init"
        :type="formulir.type"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import ListJenjang from '../base/ListJenjang';
import FormKriteria from './form/Kriteria';
import FormKuota from './form/Kuota';
import DetailPenilaian from './detail/Penilaian';
export default {
  name: 'seleksi-index',
  mixins: [list],
  components: { ListJenjang, FormKriteria, FormKuota, DetailPenilaian },
  data() {
    return {
      formulir: {},
    };
  },

  methods: {
    ...mapActions('peringkat', ['detail', 'save']),

    saving(options) {
      let payloads = {
        id: options.id,
        action: 'seleksi',
        type: options.type,
      };

      if (options.params) {
        payloads['params'] = options.params;
      }

      this.save(payloads)
        .then(() => {
          this.$success(options.message || 'Data berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.$refs.jenjang.fetchData();
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    async onResetTahap(id) {
      this.saving({ id, type: 'reset', message: 'Tahap berhasil direset' });
    },

    async onKriteria(jenjang) {
      const mode = +jenjang.k_proses_peringkat_psp >= 2 ? 'detail' : 'form';
      const title = `${mode === 'form' ? '1. Set Kriteria - ' : ''}Detail Bobot Kriteria Penilaian`;

      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormKriteria');
      this.$set(this.formulir, 'title', title);
      this.$set(this.formulir, 'init', {});
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.component.reset();
        this.$set(this.formulir, 'init', Object.assign({}, jenjang));
      });
    },

    async onDetail(options) {
      const titles = {
        nilai: 'Detail Borang Penilaian Kepala Sekolah',
        peringkat: 'Detail Borang Penilaian Kepala Sekolah',
      };

      let title = titles[options.type];
      if (+options.jenjang.k_proses_peringkat_psp === 2) {
        title = '2. Set Penilaian - ' + title;
      } else if (+options.jenjang.k_proses_peringkat_psp === 4) {
        title = '3. Set Prioritas - ' + title;
      }

      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'form', 'DetailPenilaian');
      this.$set(this.formulir, 'title', title);
      this.$set(this.formulir, 'init', null);
      this.$set(this.formulir, 'type', options.type);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$set(this.formulir, 'init', options.jenjang);
        this.$refs.component.reset();
      });
    },

    async onKuota(options) {
      const mode = +options.jenjang.k_proses_peringkat_psp >= 8 ? 'detail' : 'form';
      const title = `${mode === 'form' ? '4.' : 'Detail'} Finalisasi Peringkat`;

      this.$set(this.formulir, 'mode', mode);
      this.$set(this.formulir, 'form', 'FormKuota');
      this.$set(this.formulir, 'title', title);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.component.reset();
        this.$set(this.formulir, 'init', Object.assign({}, options.jenjang, { instansi: options.instansi }));
      });
    },

    onSave() {
      const form = this.formulir.form || '';
      let id, params, error;

      switch (form) {
        case 'FormKriteria':
          id = this.$getDeepObj(this.formulir, 'init.psp_peringkat_jenjang_id') || '';
          params = this.$refs.component.getPersenKriteria();
          error = this.$refs.component.getErrors();

          if (error) {
            this.$error(error);
            this.$refs.modal.loading = false;
            return;
          }

          this.saving({ params, id, action: 'seleksi', type: 'save-kriteria' });
          break;
        case 'FormKuota':
          id = this.$getDeepObj(this.formulir, 'init.psp_peringkat_jenjang_id') || '';
          params = this.$refs.component.getPersenKuota();
          error = this.$refs.component.getErrors();

          if (error) {
            this.$error(error);
            this.$refs.modal.loading = false;
            return;
          }

          this.saving({ params, id, action: 'seleksi', type: 'save-kuota' });
          break;
      }
    },

    onClose() {
      if (this.formulir.mode === 'detail') {
        if (this.formulir.form === 'DetailPenilaian') {
          this.$refs.jenjang.fetchData();
        }

        this.$refs.modal.dialog = false;
        return;
      }

      this.$confirm('Anda yakin ingin keluar dari halaman ini ?', 'Konfirmasi').then(() => {
        this.$refs.modal.dialog = false;
      });
    },
  },
};
</script>

<style scoped></style>
